import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(0),
      catchError((error: HttpErrorResponse) => {
        let errorMessage: string;
        console.log('error', error);
        if (error.error) {
          errorMessage = `Error: ${error.error.message}`; // client-side error
        } else {
          errorMessage = `Error Status: ${error.status}\nMessage: ${error.statusText}`; // server-side error
        }
        return throwError(() => error['error']);
      }),
    );
  }
}
